import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  errorMsg: "",
  transactionHistoryList: null,
  totalItems: 0,
  pageNumber: 1,
  totalPage: 1,
  // onramp transactions state
  onrampTransactionsList: null,
  onrampIsLoading: false,
  onrampErrorMsg: "",
  onrampTotalItems: 0,
  onrampPageNumber: 1,
  onrampTotalPage: 1,
};

const transactionSlice = createSlice({
  name: "transaction",
  initialState,
  reducers: {
    // get verification checks
    getTransactionHistoryStart: (state) => {
      state.isLoading = true;
      state.errorMsg = "";
    },
    getTransactionHistorySuccess: (state, { payload }) => {
      state.isLoading = false;
      state.errorMsg = "";
      state.transactionHistoryList = payload?.response?.data?.items;
      state.totalItems = payload?.response?.data?.totalItems;
      state.totalPage = payload?.response?.data?.itemsPerPage;
      state.pageNumber = payload?.response?.data?.startIndex;
    },
    getTransactionHistoryFail: (state, { payload }) => {
      state.isLoading = false;
      state.errorMsg = payload;
    },
    resetGetTransactionHistoryList: (state) => {
      state.transactionHistoryList = null;
    },
    // get onramp transactions
    getOnrampTransactionsStart: (state) => {
      state.onrampIsLoading = true;
      state.onrampErrorMsg = "";
    },
    getOnrampTransactionsSuccess: (state, { payload }) => {
      state.onrampIsLoading = false;
      state.onrampErrorMsg = "";
      state.onrampTransactionsList = payload?.response?.data?.items;
      state.onrampTotalItems = payload?.response?.data?.totalItems;
      state.onrampTotalPage = payload?.response?.data?.itemsPerPage;
      state.onrampPageNumber = payload?.response?.data?.startIndex;
    },
    getOnrampTransactionsFail: (state, { payload }) => {
      state.onrampIsLoading = false;
      state.onrampErrorMsg = payload;
    },
    resetOnrampTransactionsList: (state) => {
      state.onrampTransactionsList = null;
    },
  },
});
export const {
  getTransactionHistoryStart,
  getTransactionHistorySuccess,
  getTransactionHistoryFail,
  resetGetTransactionHistoryList,
  getOnrampTransactionsStart,
  getOnrampTransactionsSuccess,
  getOnrampTransactionsFail,
  resetOnrampTransactionsList,
} = transactionSlice.actions;
export const transactionReducers = transactionSlice.reducer;
